import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import i18next from '@/i18n';
import { resolvePeriodSettings, getBrowserLocale } from '@sharecost/shared';
import type { PeriodSettings } from '@sharecost/shared';

/**
 * Effective week/month start for the signed-in user: stored profile
 * preferences merged with the browser locale default (same rules as mobile).
 */
export function usePeriodSettings(): PeriodSettings {
  const { profile } = useAuth();
  const weekStartDay = profile?.week_start_day;
  const monthStartDay = profile?.month_start_day;

  return useMemo(
    () => resolvePeriodSettings({ weekStartDay, monthStartDay }, getBrowserLocale()),
    [weekStartDay, monthStartDay],
  );
}

/** Date formatter for period labels, in the language chosen in the UI (not the browser's). */
export function formatBrowserDate(date: Date, options: Intl.DateTimeFormatOptions): string {
  return date.toLocaleDateString(i18next.language || getBrowserLocale(), options);
}
